var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blankPage"},[_c('div',{staticClass:"minPage"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/image/header/404.gif"),"alt":""}}),_c('p',[_c('el-button',{attrs:{"round":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Return to homepage")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }